<template>
	<div class="chat-chat-opt">
		<div class="chat-chat-opt-title">
			<span class="chat-chat-ot-name">{{title}}</span>
			<span class="chat-chat-ot-close" @click="closeOpt">关闭</span>
		</div>
		<div class="chat-chat-opt-rt" v-if="optData.type == 'TransferAccountsOpen' || optData.type == 'RedPackageOpenResult'">
			<div class="chat-chat-orp-icon"></div>
			<div class="chat-chat-orp-detail">
				<p>您有一个<span v-html="optData.type == 'TransferAccountsOpen' ? '转账' : '红包'"></span>待领取！</p>
				<p class="chat-chat-orp-money" v-if="optData.type == 'TransferAccountsOpen'">{{optData.money}}</p>
			</div>
			<div class="chat-chat-orp-comfirm">
				<button @click="confrimRT">确认领取</button>
				<p>1天内未确认，将退还给对方。</p>
			</div>
			<div class="chat-chat-orp-time" v-if="optData.type == 'TransferAccountsOpen'">
				<p>过期时间：<span>{{optData.invalid_time | formatTimeToYMDHms}}</span></p>
			</div>
		</div>
		<div class="chat-chat-opt-rtd" v-else-if ="optData.type == 'transferAccounts' || optData.type == 'redPackage'">
			<div class="chat-chat-orpd-icon"></div>
			<div class="chat-chat-orpd-detail">
				<p v-if="optData.msgType === 'transfer_accounts_r'">您的<span  v-html="optData.type == 'transferAccounts' ? '转账' : '红包'"></span>已退回！</p>
				<p v-else>您的<span  v-html="optData.type == 'transferAccounts' ? '转账' : '红包'"></span>已领取！</p>
			</div>
			<div class="chat-chat-orpd-comfirm">
				<button @click="closeOpt">完成</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {pushRedPackageOpen_S,pushTransferAccountsOpen_S} from '../../socket/socketEventSender.js'
	
	export default{
		name:"ChatChatOpt",
		props:{
			optData:{
				type: Object,
				default: function(){
					return {
						
					}
				}
			},
			cWxName:{
				type: String,
				default: ''
			}
		},
		data(){
			return {
				title:''
			}
		},
		methods:{
			// 处理展示收取红包/转账的结果数据
			showRT(){
				if(this.optData.type === undefined){
					return
				}
				if(this.optData.type === 'TransferAccountsOpen'){
					this.title = '转账消息'
				}else if(this.optData.type === 'RedPackageOpenResult'){
					this.title = '红包消息'
				}else if(this.optData.type === 'redPackage'){
					this.title = '红包收取成功'
				}else if(this.optData.type === 'transferAccounts'){
					this.title = '转账收取成功'
				}
			},
			
			// 确认收取红包/转账
			confrimRT(){
				if(this.optData.type === undefined){
					CHAT_LAYER.msg('错误的消息类型，请重新打开！',{icon:2})
					return
				}
				CHAT_LAYER.msg('指令推送成功，请稍后！',{icon:1})
				// 发起确认收取转账指令
				if(this.optData.type === 'TransferAccountsOpen'){
					pushTransferAccountsOpen_S(this.optData.trans_id,this.optData.transfer_id,this.optData.wxid,this.optData.confirm,this.optData.invalid_time,this.optData.fee,this.optData.weiI)
				}
				// 发起确认收取红包指令
				else if(this.optData.type === 'RedPackageOpenResult'){
					let cWxName = this.cWxName
					if(cWxName === undefined){
						cWxName = ''
					}
					pushRedPackageOpen_S(this.optData.sendId,this.optData.cGE,this.optData.nuh,this.optData.timingIdentifier,cWxName,this.optData.weiI)
				}
			},
			
			// 关闭页面
			closeOpt(){
				this.$emit('chat-opt-close')
			}
		},
		watch:{
			optData(nVal){
				this.showRT()
			}
		},
		created() {
			this.showRT()
		}
	}
</script>

<style>
	.chat-chat-opt{
		position: absolute;
		height: auto;
		width: 300px;
		top: 50%;
		left: 50%;
		background-color: #FFFFFF;
		z-index: 11;
		transform: translate(-50%,-50%);
	}
	.chat-chat-opt-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ot-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-opt-rt,.chat-chat-opt-rtd{
		padding: 10px;
		text-align: center;
	}
	.chat-chat-opt-rt .chat-chat-orp-icon{
		margin-top: 10px;
		height: 36px;
		background-image: url(../../assets/img/await.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 36px;
	}
	.chat-chat-opt-rt .chat-chat-orp-detail{
		padding: 20px 0;
	}
	.chat-chat-orp-detail p{
		line-height: 26px;
	}
	.chat-chat-orp-detail .chat-chat-orp-money{
		font-size: 20px;
		font-weight: bold;
	}
	.chat-chat-orp-detail span{
		font-weight: bold;
		display: inline-block;
		padding: 0 5px;
		color: #ff1f1f;
	}
	.chat-chat-opt-rt .chat-chat-orp-comfirm{
		padding-bottom: 20px;
	}
	.chat-chat-orp-comfirm button{
		padding: 5px 20px;
		background-color: #42B983;
		color: #FFFFFF;
		cursor: pointer;
		margin-bottom: 8px;
		border-radius: 4px;
	}
	.chat-chat-orp-comfirm p{
		font-size: 12px;
		color: #888888;
	}
	.chat-chat-opt-rt .chat-chat-orp-time{
		padding: 10px 0;
		font-size: 12px;
		color: #888888;
	}
	.chat-chat-opt-rtd .chat-chat-orpd-icon{
		margin-top: 10px;
		height: 36px;
		background-image: url(../../assets/img/complete.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 36px;
	}
	.chat-chat-opt-rtd .chat-chat-orpd-detail{
		padding: 20px 0;
	}
	.chat-chat-orpd-detail p{
		line-height: 26px;
	}
	.chat-chat-orpd-detail .chat-chat-orpd-money{
		font-size: 20px;
		font-weight: bold;
	}
	.chat-chat-orpd-detail span{
		font-weight: bold;
		display: inline-block;
		padding: 0 5px;
		color: #ff1f1f;
	}
	.chat-chat-opt-rtd .chat-chat-orpd-comfirm{
		padding-bottom: 10px;
	}
	.chat-chat-orpd-comfirm button{
		padding: 5px 20px;
		background-color: #42B983;
		color: #FFFFFF;
		cursor: pointer;
		margin-bottom: 8px;
		border-radius: 4px;
	}
</style>
